import SvgIcon from "@mui/material/SvgIcon";

type Props = {
  className?: string;
};

const ProfileIcon = ({ className }: Props) => (
  <SvgIcon className={className}>
    <svg viewBox="0 0 24 24" x="0px" xmlns="http://www.w3.org/2000/svg" y="0px">
      <path
        d="M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0,2c-2.67,0-8,1.34-8,4v2H20V18C20,15.34,14.67,14,12,14Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export { ProfileIcon };
